import Vue from 'vue'

export default {
  getSavedMedications () {
    return Vue.http.get(window.API_URL + 'doctors/doctor_saved_medications')
  },
  addToSavedMedications (data) {
    return Vue.http.post(window.API_URL + 'doctors/doctor_saved_medications', data)
  },
  editSavedMedication (data) {
    return Vue.http.patch(window.API_URL + `doctors/doctor_saved_medications/${data.doctor_saved_medication_id}`, data.med)
  },
  removedSavedMedication (id) {
    return Vue.http.delete(window.API_URL + `doctors/doctor_saved_medications/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/pre_filled_medications.js